import React, { useMemo, useState } from 'react';
import { Modal, ModalBody, ModalHeader } from './styles';
import { LoginButton } from '../../pages/Login/styles';
import { baseApi } from '../../services/utils';
import useStore from '../../services/hooks/useStore';
import { TextField } from '@material-ui/core';
import Formatter from '../../services/Formatter';

const RECOVERY_ATTEMPTS_KEY = 'recoveryAttempts';
const MAX_ATTEMPTS = 3;
const ATTEMPT_WINDOW_MS = 5 * 60 * 1000; // 5 minutos

const ModalResetarSenha: React.FC<ModalProps> = ({ open, handleClose }) => {
  const [usuario, setUsuario] = useState('');

  const store = useStore();

  function mudarUsuario(e: React.ChangeEvent<HTMLInputElement>): void {
    setUsuario(e.target.value);
  }

  const isEmail = useMemo(() => usuario.includes('@'), [usuario]);


  function canAttempt(): { allowed: boolean; waitMs: number } {
    const now = Date.now();
    const raw = localStorage.getItem(RECOVERY_ATTEMPTS_KEY);
    const arr: number[] = raw ? JSON.parse(raw) : [];
    const filtered = arr.filter((t) => now - t < ATTEMPT_WINDOW_MS);
    if (filtered.length >= MAX_ATTEMPTS) {
      const oldest = filtered[0];
      return { allowed: false, waitMs: ATTEMPT_WINDOW_MS - (now - oldest) };
    }
    return { allowed: true, waitMs: 0 };
  }

  function registerAttempt(): void {
    const now = Date.now();
    const raw = localStorage.getItem(RECOVERY_ATTEMPTS_KEY);
    const arr: number[] = raw ? JSON.parse(raw) : [];
    arr.push(now);
    const filtered = arr.filter((t) => now - t < ATTEMPT_WINDOW_MS);
    localStorage.setItem(RECOVERY_ATTEMPTS_KEY, JSON.stringify(filtered));
  }

  async function recuperarSenha(): Promise<void> {
    const attempt = canAttempt();
    if (!attempt.allowed) {
      const seconds = Math.ceil(attempt.waitMs / 1000);
      store.notificar(`Muitas tentativas. Tente novamente em ${seconds}s.`);
      return;
    }
    registerAttempt();

    const value = usuario.trim();
    const payload = { user_login: isEmail ? value : Formatter.getNumeros(value) };

    try {
      await baseApi.post('/auth/recovery/', payload);
      store.notificar('Verifique a caixa de entrada do seu email. Enviamos um link para você redefinir sua senha. Ele perderá validade em 2 horas.');
      if (handleClose) handleClose();
    } catch (err: any) {
      const msg =
        err?.response?.data?.detail ||
        err?.response?.data?.error ||
        'Aconteceu um erro! Verifique as informações';
      store.notificar(msg);
    }
  }
  return (
    <Modal onClose={handleClose} open={open}>
      <ModalHeader>Recuperação de Senha</ModalHeader>
      <ModalBody>
        <p>Para recuperar sua senha, insira abaixo seu CPF/CNPJ ou EMAIL.</p>
        <TextField
          inputProps={{ 'aria-label': 'Informe o CPF/CNPJ ou EMAIL' }}
          style={{ margin: '10px 0' }}
          label="Informe o CPF/CNPJ ou EMAIL"
          value={usuario}
          onChange={mudarUsuario}
          type={isEmail ? 'email' : 'text'}
          fullWidth
        />
        <LoginButton onClick={recuperarSenha} variant="contained" color="primary" style={{ marginTop: 10 }}>
          RECUPERAR SENHA
        </LoginButton>
      </ModalBody>
    </Modal>
  );
};

export default ModalResetarSenha;
